import React, { useReducer } from 'react';
import Header from './Header';

const AppContent = ({ children, dark, full_height }) => {

    let variantClass = dark ? "AppContent--dark" : "AppContent--light" 
    variantClass += full_height ? ' h-screen' : ''

    return <div className={"AppContent" + " " + variantClass + " flex flex-col "} dark={dark}>
        <Header />

        {children}
    </div>;
};

AppContent.defaultProps = {
    dark: false,
    full_height: false
}


export default AppContent;
